import { render, staticRenderFns } from "./NewTuEstadoCuenta.vue?vue&type=template&id=1d8c1148&scoped=true"
import script from "./NewTuEstadoCuenta.vue?vue&type=script&lang=ts"
export * from "./NewTuEstadoCuenta.vue?vue&type=script&lang=ts"
import style0 from "./NewTuEstadoCuenta.vue?vue&type=style&index=0&id=1d8c1148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c1148",
  null
  
)

export default component.exports